import { render, staticRenderFns } from "./RelatedItems.vue?vue&type=template&id=10d894a0&"
import script from "./RelatedItems.vue?vue&type=script&lang=js&"
export * from "./RelatedItems.vue?vue&type=script&lang=js&"
import style0 from "./RelatedItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports